// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"4144e534","266":"9a52dedd","449":"2238962a","839":"ccb084c6"}[chunkId] + ".chunk.js";
};